module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0060.jpg?v=2fc23881";